var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.25 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#9964f2;stroke-width:3px;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Public---Review-Request"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Request-Screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M46.44,35.72a3,3,0,0,0-.83,2.63L48.07,53a2.91,2.91,0,0,1-4.2,3.12L31,49.22a2.87,2.87,0,0,0-2.7,0L15.39,56.15A2.91,2.91,0,0,1,11.18,53l.36-2.16,2.1-12.52a3,3,0,0,0-.83-2.63L2.38,25.33A3,3,0,0,1,4,20.27L18.4,18.13a2.91,2.91,0,0,0,2.18-1.62L27,3.15a2.87,2.87,0,0,1,5.19,0l6.45,13.36a2.91,2.91,0,0,0,2.18,1.62l4.46.66,9.95,1.48a3,3,0,0,1,1.61,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-2",
    d: "M46.47,35.74a3,3,0,0,0-.83,2.63L48.09,53a2.9,2.9,0,0,1-4.19,3.12L31,49.23a2.79,2.79,0,0,0-2.69,0L15.49,56.15A2.91,2.91,0,0,1,11.29,53l.36-2.16c22.54-9.84,30.94-22.15,33.69-32l9.93,1.48a3,3,0,0,1,1.6,5.05Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.2d9e7a555a397d75b30ae477e09ebeb3.svg";
export { ForwardRef as ReactComponent };